var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Prop, Emit } from 'vue-facing-decorator';
let OhmicStringSelectionModal = class OhmicStringSelectionModal extends Vue {
    constructor() {
        super(...arguments);
        this.isVisible = false;
        this.selectedStringId = -1;
    }
    show() {
        var _a;
        this.isVisible = true;
        this.selectedStringId = (_a = this.preSelectedStringId) !== null && _a !== void 0 ? _a : -1;
    }
    getStringState(stringId) {
        const state = this.stringStates.find(s => s.stringId === stringId);
        return state ? state.state : '';
    }
    isOnfloat(stringId) {
        const state = this.stringStates.find(s => s.stringId === stringId);
        return state ? state.state.toLowerCase() === 'float' : false;
    }
    onHidden() {
        this.selectedStringId = -1;
    }
    onOk() {
        return this.selectedStringId;
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", Array)
], OhmicStringSelectionModal.prototype, "strings", void 0);
__decorate([
    Prop({ required: true }),
    __metadata("design:type", Array)
], OhmicStringSelectionModal.prototype, "stringStates", void 0);
__decorate([
    Prop({ default: null }),
    __metadata("design:type", Object)
], OhmicStringSelectionModal.prototype, "preSelectedStringId", void 0);
__decorate([
    Emit(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], OhmicStringSelectionModal.prototype, "onHidden", null);
__decorate([
    Emit('selection'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Object)
], OhmicStringSelectionModal.prototype, "onOk", null);
OhmicStringSelectionModal = __decorate([
    Component({
        name: 'OhmicStringSelectionModal'
    })
], OhmicStringSelectionModal);
export default OhmicStringSelectionModal;
